import React, { createContext, useContext, useState, ReactNode } from "react";

interface LeftbarContextProps {
  showLeftbar: boolean;
  setShowLeftbar: React.Dispatch<React.SetStateAction<boolean>>;
}

const LeftbarContext = createContext<LeftbarContextProps | undefined>(undefined);

export const LeftbarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showLeftbar, setShowLeftbar] = useState(true);

  return (
    <LeftbarContext.Provider
      value={{
        showLeftbar,
        setShowLeftbar,
      }}
    >
      {children}
    </LeftbarContext.Provider>
  );
};

export const useLeftbarBar = (): LeftbarContextProps => {
  const context = useContext(LeftbarContext);
  if (!context) {
    throw new Error("useLeftbar must be used within a LeftbarProvider");
  }
  return context;
};
